import { ref } from 'vue'

export function useGenderSelection() {
  const selectedGender = ref<'male' | 'female' | null>(null)

  const genderImages = {
    male: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Fmale.avif?alt=media&token=cd400171-1400-4adb-a374-c406ec5f2ab6',
    female: 'https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fquiz%2Ffemale.avif?alt=media&token=654cd3a9-db0e-41fb-adb3-26ec61fdeca1'
  }

  const genderLabels = {
    male: 'Masculino',
    female: 'Feminino'
  }

  const selectGender = (gender: 'male' | 'female') => {
    selectedGender.value = gender
  }

  return {
    selectedGender,
    genderImages,
    genderLabels,
    selectGender
  }
}